import type { Position } from 'components/map/types';
import type { GeoPositionFE } from 'domain/vehicle';

import { RioPositionSchema } from './zod';

import type { PositionInput } from 'API';

export const transformToRioPosition = ({ latitude, longitude }: PositionInput): Position =>
    RioPositionSchema().parse({
        lat: latitude,
        lng: longitude,
    });

export const toRioPosition = ({ lat, lng }: GeoPositionFE): Position => ({ lat, lng });
